import {createSelector} from 'reselect';

import type {NutshellState} from '../../../../store';

export const getListSelectionState = (state: NutshellState) => state.peopleListSelection;

const getSelectedItems = createSelector(
    [getListSelectionState],
    (listSelectionState) => listSelectionState.selectedItems
);

export const getAudienceListSelectedItems = createSelector(
    [getSelectedItems],
    (audienceListSelectionState) => audienceListSelectionState.items
);
export const getAudienceListSelectionIsExcluded = createSelector(
    [getSelectedItems],
    (audienceListSelectionState) => audienceListSelectionState.isExcluded
);
